import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { CreateSurveyDtoPriorityEnum, CreateSurveyDtoAnonymizationTypeEnum, CreateSurveyDtoSendStrategyEnum } from '../typescript-axios';

export const useAddSurveysValidationSchema = () => {
  const { t } = useTranslation();

  return Yup.object({
    name: Yup.string()
      .required(t('pages.surveys.name_required'))
      .matches(/^[a-zA-Z0-9\-_\sñÑáéíóúÁÉÍÓÚüÜ]*$/, t('pages.surveys.name_invalid'))
      .matches(/^[^<>]*$/, t('pages.surveys.name_invalid_characters')),

    description: Yup.string().matches(
      /^[^<>]*$/,
      t('pages.surveys.description_invalid_characters')
    ),

    study: Yup.string().matches(
      /^[^<>]*$/,
      t('pages.surveys.study_invalid_characters')
    ),

    template: Yup.array()
      .of(
        Yup.object({
          name: Yup.string().required(t('pages.surveys.field_name_required')),
          type: Yup.string().required(t('pages.surveys.field_type_required')),
          required: Yup.boolean(),
        })
      )
      .min(1, t('pages.surveys.template_required')),

    priority: Yup.string()
      .oneOf([CreateSurveyDtoPriorityEnum.Mandatory, CreateSurveyDtoPriorityEnum.Optional])
      .required(t('pages.surveys.priority_required')),

    send_frequency_days: Yup.number().min(
      1,
      t('pages.surveys.frequency_min')
    ),

    response_time_limit_days: Yup.number().min(
      1,
      t('pages.surveys.response_time_min')
    ),

    starts_at: Yup.string()
      .required(t('pages.surveys.start_date_required'))
      .typeError(t('pages.surveys.start_date_invalid')),

    anonymization_type: Yup.string()
      .oneOf([CreateSurveyDtoAnonymizationTypeEnum.None, CreateSurveyDtoAnonymizationTypeEnum.AllAnswers, CreateSurveyDtoAnonymizationTypeEnum.Optional])
      .required(t('pages.surveys.anonymization_required')),

    send_strategy: Yup.string()
      .oneOf([CreateSurveyDtoSendStrategyEnum.AllUsers, CreateSurveyDtoSendStrategyEnum.AdminOnly])
      .required(t('pages.surveys.send_strategy_required')),

    organization_ids: Yup.array().of(Yup.string()),
  });
};
